import { TechinicalOutputDTO } from './types';

export const TechinicalMapper = {
  toDTO: (data: Partial<TechinicalOutputDTO>): Partial<TechinicalOutputDTO> => {
    return {
      ...data,
    };
  },

  toView: (data: TechinicalOutputDTO): TechinicalOutputDTO => {
    return data; // Return the same object for now, can be expanded if needed
  },
}; 